module.exports = __webpack_public_path__ + "img/video1.10173d98.jpg";